import * as Yup from "yup";
import { STATUS_BADGE_TYPE } from "../../../components/statusBadge/StatusBadge";
import {
  alphabetOrSpecialCharNotAllowedValidation,
  greaterThanZeroValidation,
  specialCharactersNotAllowedValidation,
  specialCharactersNotAllowedValidationForOptionalField,
} from "../../../helpers/constants/commonValidationSchemaUtils";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { MdmCreateOfficeFormKeys } from "./models";

export const MdmCreateOfficeSchema = (commonValidationMessages: KeyValueMap) =>
  Yup.object().shape({
    [MdmCreateOfficeFormKeys.officeName]: specialCharactersNotAllowedValidation(
      commonValidationMessages.requiredValidation,
      commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
    ),
    [MdmCreateOfficeFormKeys.parentOfficeId]: Yup.string(),
    [MdmCreateOfficeFormKeys.officeCode]: greaterThanZeroValidation(
      commonValidationMessages.greaterThanZeroFieldValidator,
    )
      .required(commonValidationMessages.requiredValidation)
      .concat(
        alphabetOrSpecialCharNotAllowedValidation(
          commonValidationMessages.alphabetOrSpecialCharNotAllowed,
        ),
      )
      .min(3, commonValidationMessages.mustBeThreeDigitsErrorMessage)
      .default(""),
    [MdmCreateOfficeFormKeys.officeType]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.marketId]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.regionId]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.billingOfficeId]: Yup.string().when(
      MdmCreateOfficeFormKeys.isBillingOffice,
      {
        is: false,
        then: (schema) =>
          schema.required(commonValidationMessages.requiredValidation),
        otherwise: (schema) => schema,
      },
    ),
    [MdmCreateOfficeFormKeys.salesCreditOfficeId]: Yup.string().when(
      MdmCreateOfficeFormKeys.isSalesCreditOffice,
      {
        is: false,
        then: (schema) =>
          schema.required(commonValidationMessages.requiredValidation),
        otherwise: (schema) => schema,
      },
    ),
    [MdmCreateOfficeFormKeys.currencyId]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.invoiceTemplateId]: Yup.string(),
    [MdmCreateOfficeFormKeys.salesCreditTemplateId]: Yup.string(),
    [MdmCreateOfficeFormKeys.defaultTax]: Yup.array().of(Yup.string()),
    [MdmCreateOfficeFormKeys.statusId]: Yup.string().default(
      STATUS_BADGE_TYPE.active,
    ),
    [MdmCreateOfficeFormKeys.timeZoneKey]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.address1]: specialCharactersNotAllowedValidation(
      commonValidationMessages.requiredValidation,
      commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
    ),
    [MdmCreateOfficeFormKeys.address2]:
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ),
    [MdmCreateOfficeFormKeys.address3]:
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ),
    [MdmCreateOfficeFormKeys.countryId]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.city]: specialCharactersNotAllowedValidation(
      commonValidationMessages.requiredValidation,
      commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
    ),
    [MdmCreateOfficeFormKeys.businessUnitId]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.state]:
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ),
    [MdmCreateOfficeFormKeys.postalCode]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [MdmCreateOfficeFormKeys.isSalesCreditOffice]: Yup.boolean().default(false),
    [MdmCreateOfficeFormKeys.isBillingOffice]: Yup.boolean().default(false),
    [MdmCreateOfficeFormKeys.header]: Yup.string().when(
      MdmCreateOfficeFormKeys.isBillingOffice,
      {
        is: true,
        then: (schema) =>
          schema.required(commonValidationMessages.requiredValidation),
        otherwise: (schema) => schema,
      },
    ),
    [MdmCreateOfficeFormKeys.footer1]: Yup.string(),
    [MdmCreateOfficeFormKeys.footer2]: Yup.string(),
    [MdmCreateOfficeFormKeys.footer3]: Yup.string(),
  });
